module.exports = "<div>\r\n  <object\r\n    ng-if='$ctrl.type === \"pdf\"'\r\n    data=\"{{$ctrl.url}}\"\r\n    type=\"application/pdf\"\r\n    class=\"preview-pdf\"\r\n  >\r\n    {{ 'Unable to display file.' | translate }}\r\n  </object>\r\n  <img\r\n    ng-if='$ctrl.type !== \"pdf\"'\r\n    src=\"{{$ctrl.url}}\"\r\n    class=\"preview-image\"\r\n    alt=\"{{ 'Preview' | translate }}\"/>\r\n</div>\r\n\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/file-preview/components/file-preview/file-preview.html
// module id = 1894
// module chunks = 0